module.exports = __webpack_public_path__ + "static/media/md-color-filter.7058497f.svg";